<template>
    <div class="m-task">
        <div class="m-user"><user-info/></div>

        <div class="task-view">
            <div class="header"></div>

            <div class="task-history">
                <div class="part-total">阿斗赶集参与期数：{{ task_info.terms || 0 }}</div>
                <div class="charge-total">阿斗赶集累计消费：<b>{{ task_info.costs || 0 }}</b></div>
            </div>

            <div class="main-task-gift">
                <div class="list-pannel">
                    <div class="list-item" v-for="(item,index) in task_config.involved" :key="index">
                        <h5>{{ item.itemName }}</h5>

                        <div class="goods-detail">
                            <div class="goods-wrapper">
                                <div class="goods-pic" v-tips="item.giftId"><game-item :locked="true" :id="item.giftId" :num="item.sendNum"></game-item></div>
                            </div>  
                        </div>

                        <div class="u-btn apply" 
                        :class="{'disabled' : task_info[item.flag] == 0 , 'dismiss' : task_info[item.flag] == 2 ,}" 
                        @click="apply(item.type,item.value)"></div>

                        <div class="notice">{{ item.notice }}</div>
                    </div>
                </div>                
            </div>

            <div class="task-list">
                <div class="title cnt"></div>
                <div class="task-pannel">
                    <div class="pannel-body"></div>
                    <div class="pannel-content">
                        <ul>
                            <li v-for="(item,key) in task_info.buyGift" :key="'n-' + key">
                                <div class="task-content">
                                    本期阿斗赶集购买<b>{{ item.value }}</b>件商品，
                                    <p>可获得<span>（{{ task_info.goods }}/<b>{{ item.value }}</b>）</span></p>
                                </div>

                                <div class="task-detail">
                                    <div class="goods-detail">
                                        <div class="goods-wrapper">
                                            <div class="goods-pic" v-tips="item.gift"><game-item :locked="true" :id="item.gift" :num="item.num"></game-item></div>
                                        </div>  
                                    </div>                              
                                    <div class="u-btn apply" @click="apply(3,item.value)" :class="{ 'disabled' : item.state == 0 , 'dismiss' : item.state == 2}"></div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="task-list">
                <div class="title his"></div>
                <div class="task-pannel">
                    <div class="pannel-body"></div>
                    <div class="pannel-content">
                        <ul>
                            <li v-for="(item,key) in task_info.termGift" :key="'n-' + key">
                                <div class="task-content">
                                    参与阿斗赶集共<b>{{ item.value }}</b>期，
                                    <p>可获得<span>（{{ task_info.terms || 0 }}/<b>{{ item.value }}</b>）</span></p>
                                </div>

                                <div class="task-detail">
                                    <div class="goods-detail">
                                        <div class="goods-wrapper">
                                            <div class="goods-pic" v-tips="item.gift"><game-item :locked="true" :id="item.gift" :num="item.num"></game-item></div>
                                        </div>  
                                    </div>                                   
                                    <div class="u-btn apply" @click="apply(4,item.value)" :class="{ 'disabled' : item.state == 0 , 'dismiss' : item.state == 2}"></div>
                                </div>
                            </li>
                        </ul>                        
                    </div>
                </div>
            </div>
            <div class="task-list">
                <div class="title charge"></div>
                <div class="task-pannel">
                    <div class="pannel-body"></div>
                    <div class="pannel-content">
                        <div class="notice"><em class="i-warn"></em>历史累计消费奖励将在本期结束后清空并更新，请及时领取</div>
                        <ul>
                            <li v-for="(item,key) in task_info.costGift" :key="'n-' + key">
                                <div class="task-content">
                                    阿斗赶集历史累计消费达<b>{{ item.value }}</b><em class="icon-m3b"></em>，
                                    <p>可获得<span>（{{ task_info.costs || 0 }}/<b>{{ item.value }}</b>）</span></p>
                                </div>

                                <div class="task-detail">
                                    <div class="goods-detail">
                                        <div class="goods-wrapper">
                                            <div class="goods-pic" v-tips="item.gift"><game-item :locked="true" :id="item.gift" :num="item.num"></game-item></div>
                                        </div>  
                                    </div>                                   
                                    <div class="u-btn apply" @click="apply(5,item.value)" :class="{ 'disabled' : item.state == 0 , 'dismiss' :item.state == 2}"></div>
                                </div>
                            </li>
                        </ul>                         
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import task_config from '@/components/giftdic.js'

export default {
    data (){
        return {
            task_info : {},
            task_config : task_config,
        }
    },
    mounted (){
        this.render();
    },
    methods : {
        render (){
            this.$get(ajax_url_map.task_info,{
                success : (data) => {
                    this.task_info = data.data;
                }
            })
        },
        query_data(val,data){
            data = data || [];
            let ret = {};
            for(var i = 0 ; i < data.length;i++){
                if(data[i].value == val){
                    ret = data[i];
                }
            }

            return ret;
        },
        apply (type,value){

            if(!type){
                throw new Error('缺少type');
            }

            this.$post(ajax_url_map.apply_task,{
                success : (data) => {
                    this.$msg_modal('领取成功');
                    this.render();
                },
                error : (data) => {
                    this.$msg_modal(data.message);
                },
            },{
                type : type,
                value : value,
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.m-task{
    padding-top: 604px;
}

.m-user{
    width: 750px;
    height: 48px;
    line-height: 48px;
    margin: 0 auto;
    background-image: url(~@/assets/images/bg-userinfo.png);
}

.task-view{
    width: 750px;
    min-height: 2382px;
    padding-bottom: 200px;
    margin: 0 auto;
    background-image: url(~@/assets/images/task/bg-task.png);
    background-repeat: repeat-y;

    .header{
        width: 750px;
        height: 156px;
        margin: 0 auto 30px;
        background-image: url(~@/assets/images/task/header-task.png);
    }

    .goods-detail{
        .goods-wrapper{
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            width: 118px;
            height: 118px;
            margin: 0 auto;
            background-image: url(~@/assets/images/shop/bg-item.png);
        }

        .goods-pic{
            width: 69px;
            height: 69px;
            border: 2px solid #ccae62;
        }
    }


    .u-btn.apply{
        width: 232px;
        height: 89px;
        background-image: url(~@/assets/images/task/btn-apply.png);

        &.disabled{
            background-image: url(~@/assets/images/task/btn-apply_disabled.png);
        }

        &.dismiss{
            background-image: url(~@/assets/images/task/btn-apply_dismiss.png);
        }        
    }

}

.task-history{
    text-align: center;

    .part-total{
        font-size: 22px;
        color: #dccdc1;
    }

    .charge-total{
        width: 690px;
        height: 50px;
        line-height: 50px;
        margin: 10px auto 0;
        color: #e5d98f;
        background-image: url(~@/assets/images/task/bg-charge.png);
    }
}

.list-pannel{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 18px 20px 0;

    .list-item{
        position: relative;
        width: 331px;
        height: 624px;
        padding-top: 48px;
        background-image: url(~@/assets/images/task/item-pannel.png);
        text-align: center;

        h5{
            margin-bottom: 50px;
            padding: 0 60px;
            font-size: 28px;
            font-weight: 700;
            color: #7f572d;
        }

        .u-btn.apply{
            margin: 37px auto 20px;
        }

        .notice{
            padding: 0 24px;
            color: #d33d27;
        }
    }
}

.task-list{
    .title{
        width: 750px;
        height: 77px;
        margin:  20px auto 18px;

        &.cnt{
            background-image: url(~@/assets/images/task/title-cnt.png);
        }

        &.his{
            background-image: url(~@/assets/images/task/title-his.png);
        }
        
        &.charge{
            background-image: url(~@/assets/images/task/title-charge.png);
        }        
    }

    .notice{
        margin-bottom: 20px;
        padding: 0 24px;
        font-size: 20px;
        color: #d33d27;
        text-align: center;
    }

    .i-warn{
        display: inline-block;
        width: 21px;
        height: 21px;
        margin-right: 15px;
        background-image: url(~@/assets/images/modal/icon-warn.png);
        vertical-align: middle; 
    } 
    
    .task-pannel{
        position: relative;
        width: 690px;       
        margin: 0 auto;
        background: url(~@/assets/images/task/pannel-head.png) center top no-repeat,
                    url(~@/assets/images/task/pannel-footer.png) center bottom no-repeat;
        background-size: 100% auto;

        .pannel-body{
            position: absolute;
            left:0;
            top:38px;
            bottom:38px;
            width:100%;
            background: url(~@/assets/images/task/pannel-body.png) left top repeat-y;
            background-size: 100% auto;          
        }

        .pannel-content{
            position: relative;
            min-height: 400px;
            padding: 25px 0 7px;
            color: #7f572d;

            .task-content{
                //font-size: 22px;
            }

            b{
                color: #d33d27;
            }

            span{
                color: #a0938a;

                b{
                    color: #d33d27;
                }                
            }

            ul{
                padding: 0 22px;

                li{
                    margin-bottom: 18px;
                    border-bottom: 1px solid #e1dccd;
                }

                li:last-child{
                    border-bottom: none;
                }
                
            }

            .task-detail{
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-top: 16px;
                margin-bottom: 20px;
            }
        }
    }
}
</style>